module.exports = __webpack_public_path__ + "static/media/infoIcon.d5eea266.png";